import { ModelMapper } from "@api/mappers/mappers.types";
import { ProductTileModel } from "@api/mappers/products.mapper";

import { ProductImpressionModel } from "../types/trackingInfo/productImpressionmodel";

export const ProductTileToProductImpressionModel: ModelMapper<
    ProductTileModel,
    ProductImpressionModel
> = model => {
    return {
        product: {
            sku: model.sku,
            ean: model.ean,
            productTitle: model.title,
            brandName: model.brand?.name,
            analytics: model.analytics,
            currentPrice: model.salesPrice,
            roundedDiscountPercentage: model.discountPercentage
                ? Math.floor(model.discountPercentage)
                : null,
        },
    };
};
